import React from 'react';
import { Header, Seo } from '@layout';
import { getRootUrl } from '@utils/urlHelpers.util';
import { WeddingWritersUnblocker } from '@sections/chat-gpt';
import { ScrollControllerProvider } from '@context/ScrollControllerProvider/ScrollControllerProvider';
import { ShopStorefrontProvider } from '@utils/storefront/ShopStorefrontProvider';
import { useTranslation } from 'react-i18next';

const ChatGPT_PAGE: MarcomPageName = `writersblock`;

const ChatGPT: React.FC = () => {
  const canonicalURL = getRootUrl(`/${ChatGPT_PAGE}`);
  const { t } = useTranslation('chatGPT');
  const seo = t('seo');

  return (
    <>
      <ShopStorefrontProvider page={ChatGPT_PAGE}>
        <ScrollControllerProvider scrollPosition={{ x: 0, y: 0 }}>
          <Header
            isTransparent={true}
            transparentJoyLogoColor="newPurple5"
            transparentHeaderLinkVariant="navLink"
            transparentHeaderButtonVariant="primary"
            page={ChatGPT_PAGE}
          />
        </ScrollControllerProvider>
      </ShopStorefrontProvider>
      <Seo
        title={seo.title}
        description={seo.content}
        canonicalURL={canonicalURL}
        ogImage={'common/meta_share/writers-block-sharing.png'}
      />
      <WeddingWritersUnblocker />
    </>
  );
};

export default ChatGPT;
